exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datepicker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  border: 1px solid #dddddd;\n  border-radius: 5px; }\n  .datepicker input {\n    margin-left: 10px;\n    border: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-renovar-dialog/agris-cotiz-detalle-renovar-dialog.component.scss
// module id = ../../../../../src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-renovar-dialog/agris-cotiz-detalle-renovar-dialog.component.scss
// module chunks = 0